import { EumSearchBase, SearchState } from '../eum-search-base.js';
import { searchService } from '../core/services/search-service.js';
import { navigationService } from '../core/services/navigation-service.js';
import { bootstrapSheet } from '../core/styles/bootstrap.js';
import { eumBaseSheet } from '../core/styles/eum-base.js';
// @ts-ignore — handled by esbuild inline-css plugin
import componentSheet from './eum-navigation-builder.css';
// @ts-ignore — no bundled types
import Sortable from 'sortablejs';

// ── Types ───────────────────────────────────────────────────────────
export interface NavItem {
    id: string;
    type: 'link' | 'label' | 'page';
    title: string;
    url: string | null;
    target: '_self' | '_blank' | null;
    visible: boolean;
    children: NavItem[];
    pageId?: string | null;
    navId?: string | null;
    cssClass?: string | null;
    collapsed?: boolean; 
    hideChildrenInParent?: boolean;
    matchThisURL?: boolean;
}

export type NavSchema = Array<Omit<NavItem, 'id'>>;

// ── Icons (inline SVG, since bootstrap-icons font isn't in shadow DOM) ──
const ICON = {
    signpost: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M7 1.414V4H2a1 1 0 0 0-.8.4L.05 5.9a.5.5 0 0 0 0 .6L1.2 8a1 1 0 0 0 .8.4h5v7h2V13h4.5a1 1 0 0 0 .8-.4l1.15-1.5a.5.5 0 0 0 0-.6L14.3 9a1 1 0 0 0-.8-.4H9V6h4.5a1 1 0 0 0 .8-.4l1.15-1.5a.5.5 0 0 0 0-.6L14.3 2a1 1 0 0 0-.8-.4H9V0H7v1.414z"/></svg>',
    download: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/><path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/></svg>',
    plus: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2z"/></svg>',
    listNested: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.5 11.5A.5.5 0 0 1 5 11h10a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zm-2-4A.5.5 0 0 1 3 7h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm-2-4A.5.5 0 0 1 1 3h10a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5z"/></svg>',
    braces: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M2.114 8.063V7.9c1.005-.102 1.497-.615 1.497-1.6V4.503c0-1.094.39-1.538 1.354-1.538h.273V2h-.376C3.25 2 2.49 2.759 2.49 4.352v1.524c0 1.094-.376 1.456-1.49 1.456v1.299c1.114 0 1.49.362 1.49 1.456v1.524c0 1.593.759 2.352 2.372 2.352h.376v-.964h-.273c-.964 0-1.354-.444-1.354-1.538V9.663c0-.984-.492-1.497-1.497-1.6zM13.886 7.9v.163c-1.005.103-1.497.616-1.497 1.6v1.798c0 1.094-.39 1.538-1.354 1.538h-.273v.964h.376c1.613 0 2.372-.759 2.372-2.352v-1.524c0-1.094.376-1.456 1.49-1.456V7.332c-1.114 0-1.49-.362-1.49-1.456V4.352C13.51 2.759 12.75 2 11.138 2h-.376v.964h.273c.964 0 1.354.444 1.354 1.538V6.3c0 .984.492 1.497 1.497 1.6z"/></svg>',
    clipboard: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/><path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/></svg>',
    check: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M13.485 1.929a.75.75 0 0 1 0 1.06L6.06 10.415a.75.75 0 0 1-1.06 0L2.515 7.929a.75.75 0 1 1 1.06-1.06L5.53 8.823l6.895-6.894a.75.75 0 0 1 1.06 0z"/></svg>',
    gripVertical: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/></svg>',
    arrowLeft: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M11.854 3.646a.5.5 0 0 1 0 .708L8.207 8l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0zM4.5 1a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-1 0v-13a.5.5 0 0 1 .5-.5z"/></svg>',
    arrowRight: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.146 3.646a.5.5 0 0 0 0 .708L7.793 8l-3.647 3.646a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708 0zM11.5 1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 1 0v-13a.5.5 0 0 0-.5-.5z"/></svg>',
    pencil: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16"><path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/></svg>',
    nodePlus: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-node-plus" viewBox="0 0 16 16"><path fill- rule="evenodd" d = "M11 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8M6.025 7.5a5 5 0 1 1 0 1H4A1.5 1.5 0 0 1 2.5 10h-1A1.5 1.5 0 0 1 0 8.5v-1A1.5 1.5 0 0 1 1.5 6h1A1.5 1.5 0 0 1 4 7.5zM11 5a.5.5 0 0 1 .5.5v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0v-2h-2a.5.5 0 0 1 0-1h2v-2A.5.5 0 0 1 11 5M1.5 7a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" /></svg>',
    trash: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16"><path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/><path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/></svg>',
    tag: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16"><path d="M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/><path d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm0 1h4.586L14 9.414 9.414 14 2 6.586V2z"/></svg>',
    windowPlus: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16"><path d="M2.5 4a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1zM4 3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0zm1.5.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/><path d="M12 1a2 2 0 0 1 2 2v3.5h-1V5H1v9a1 1 0 0 0 1 1h6.5v1H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10zM1 4h12V3a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v1z"/><path d="M13 8a.5.5 0 0 1 .5.5V10H15a.5.5 0 0 1 0 1h-1.5v1.5a.5.5 0 0 1-1 0V11H11a.5.5 0 0 1 0-1h1.5V8.5A.5.5 0 0 1 13 8z"/></svg>',
    boxArrow: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/><path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/></svg>',
    eyeSlash: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16"><path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/><path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/><path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/></svg>',
    diagram: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-1 0V8h-11v1a.5.5 0 0 1-1 0V7.5A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5v-1zm-6 8A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5v-1zm6 0A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5v-1zm6 0a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5v-1z"/></svg>',
    exclamation: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/><path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/></svg>',
    file: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16"><path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0H4zm0 1h5v3.5A1.5 1.5 0 0 0 10.5 6H13v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/></svg>',
    arrowDown: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>',
    chevronUp: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/></svg>',
    chevronRight: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/></svg>',
    upload: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/><path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/></svg>',
    copy: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2v2a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2V2zm2 2h4a2 2 0 0 1 2 2v4h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v2h1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H2z"/></svg>',
    save: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4.207a1 1 0 0 0-.293-.707L12.5 1.293A1 1 0 0 0 11.793 1H2zm2 1h6v3H4V2zm7 0h.793L14 4.207V14h-1v-5a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v5H2V2h9v2h1V2zM4 9h8v5H4V9z"/></svg>',
    compass: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 16.016a7.5 7.5 0 0 0 1.962-14.74A1 1 0 0 0 9 0H7a1 1 0 0 0-.962 1.276A7.5 7.5 0 0 0 8 16.016m6.5-7.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"/><path d="m6.94 7.44 4.95-2.83-2.83 4.95-4.949 2.83 2.828-4.95z"/></svg>',
    sidebar: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M16 3a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2zm-5-1v12H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm1 0h2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-2z"/></svg>',
    chevronBarUp: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M3.646 11.854a.5.5 0 0 0 .708 0L8 8.207l3.646 3.647a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 0 0 0 .708M2.4 5.2c0 .22.18.4.4.4h10.4a.4.4 0 0 0 0-.8H2.8a.4.4 0 0 0-.4.4"/></svg>',
    chevronBarDown: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M3.646 4.146a.5.5 0 0 1 .708 0L8 7.793l3.646-3.647a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 0-.708M1 11.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5"/></svg>',
    asterisk: '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16"><path d="M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1"/></svg>',
};

/**
 * <eum-navigation-builder> — drag-and-drop nested navigation tree builder.
 *
 * Extends EumSearchBase so it can (in the future) plug into portal search
 * to look up pages/documents and add them as nav items. Search UI is not
 * yet rendered — the search machinery is inherited but dormant until we
 * wire it in.
 *
 * Config hooks (all optional — resolved via the base class layered config):
 *   - `items` — initial NavItem tree
 *   - all standard EumSearchBase config keys (filter, url, fields, …) so
 *     downstream page-lookup features can be configured the same way as
 *     eum-search-table.
 *
 * Fires:
 *   - `eum-nav-change` NavItem[] whenever the tree mutates
 *   - `eum-nav-save`   NavItem[] when the "Save JSON" button is clicked
 */
export class EumNavigationBuilder extends EumSearchBase {
    private shadow!: ShadowRoot;

    // Nav state (kept out of the base ReactiveStore — that store models the
    // search results the base class owns, not our tree data).
    private navItems: NavItem[] = [];
    private nextId = 1;
    private editingId: string | null = null;
    private deletingId: string | null = null;
    private isNewItem = false;
    private pendingNewItem: { item: NavItem; parentId: string | null } | null = null;

    // Modal elements (kept inside the shadow root so component styles remain
    // isolated from the host page's Bootstrap theme).
    private editModalEl!: HTMLElement;
    private deleteModalEl!: HTMLElement;
    private backdropEl: HTMLElement | null = null;
    private openModalEl: HTMLElement | null = null;
    private readonly onKeydown = (e: KeyboardEvent) => {
        if (e.key !== 'Escape' || !this.openModalEl) return;
        if (this.openModalEl.getAttribute('data-bs-keyboard') === 'false') return;
        this.hideModal(this.openModalEl);
    };

    // Shadow refs
    private rootUl!: HTMLUListElement;
    private itemCountEl!: HTMLElement;
    private jsonPreviewEl: HTMLElement | null = null;

    private sortableInstances = new WeakMap<HTMLElement, any>();

    // Filter state: when set, renderTree only draws the ancestor chain and
    // descendants of the selected node. Data in navItems is untouched.
    private filterId: string | null = null;
    private filterSearchTimer: number | null = null;
    private filterActiveIdx = -1;

    // Page picker state (native combobox).
    private pageSearchAbort: AbortController | null = null;
    private pageSearchTimer: number | null = null;
    private selectedPage: { url: string; title: string; id: string } | null = null;
    private pagePickerWired = false;

    // Global UI modes.
    private debugMode = false;      // Developer diagnostics (URL: ?debug)
    private advancedMode = false;   // End-user "advanced" mode (session-only)
    private sidebarVisible = true;  // Whether the right-hand sidebar is shown (only relevant when advanced)

    // ── EumSearchBase contract ────────────────────────────────────────
    protected attachShadowRoot(): void {
        this.shadow = this.attachShadow({ mode: 'open' });
    }

    protected render(): void {
        this.shadow.adoptedStyleSheets = [bootstrapSheet, eumBaseSheet, componentSheet];

        // Pull any nav-builder–specific config from the merged config bag.
        const cfgItems = (this.config as any).items as NavItem[] | undefined;
        if (cfgItems?.length) this.navItems = this.normalizeItems(cfgItems);

        this.debugMode = new URLSearchParams(window.location.search).has('debug');
        this.sidebarVisible = true;
        const sidebarEnabled = this.advancedMode || this.debugMode;

        this.shadow.innerHTML = /*html*/ `
            <div class="eum-navigation-builder">
                <div class="card shadow-sm">
                    <div class="card-header app-header nav-toolbar bg-white d-flex align-items-center justify-content-between gap-3 py-2 px-3 border-bottom">
                        <div class="d-flex align-items-center gap-2">
                            <span class="fw-semibold d-inline-flex align-items-center gap-2 text-primary">${ICON.compass} <span class="text-body">Navigation Builder</span></span>
                            <span class="badge bg-light text-dark border rounded-pill d-inline-flex align-items-center gap-1" id="item-count">${ICON.listNested}<span class="item-count-text">0 items</span></span>
                            <span class="badge rounded-pill" id="save-status" hidden></span>
                        </div>
                        <div class="d-flex align-items-center gap-2">
                            <div class="form-check form-switch mb-0 me-1${this.debugMode ? ' d-none' : ''}" title="Show advanced tools (JSON preview, import/export)">
                                <input class="form-check-input" type="checkbox" role="switch" id="toggle-advanced" ${this.advancedMode ? 'checked' : ''}>
                                <label class="form-check-label small" for="toggle-advanced">Advanced</label>
                            </div>
                            <button id="btn-toggle-sidebar" class="btn btn-sm border btn-icon ${sidebarEnabled ? 'btn-secondary' : 'btn-light d-none'}" type="button" title="Hide sidebar" aria-pressed="true">${ICON.sidebar}</button>
                            <div class="vr mx-1 align-self-stretch"></div>
                            <button id="btn-save-server" class="btn btn-primary btn-icon" title="Save navigation to server">${ICON.save}</button>
                        </div>
                    </div>
                    <div class="card-body app-body p-3">
                        <div class="row g-4 flex-nowrap" id="layout-row">
                            <div class="${sidebarEnabled ? 'col-lg-7' : 'col-12'}" id="left-col">
                                <div class="nav-section">
                            <div class="nav-section-header d-flex align-items-center justify-content-between pb-2 mb-2 flex-wrap gap-2">
                                <span class="fw-semibold d-inline-flex align-items-center gap-2 text-primary">${ICON.listNested} <span class="text-body">Navigation Items</span></span>
                                <div class="d-flex align-items-center gap-2 flex-grow-1 justify-content-end flex-wrap">
                                    <div class="position-relative nav-filter-wrap" style="min-width: 200px; max-width: 260px;">
                                        <input type="text" id="nav-filter-input" class="form-control form-control-sm" placeholder="Filter items…" autocomplete="off" spellcheck="false">
                                        <button type="button" class="btn-close nav-filter-clear" aria-label="Clear filter" hidden></button>
                                        <div id="nav-filter-dropdown" class="list-group shadow-sm nav-filter-dropdown" hidden></div>
                                    </div>
                                    <div class="btn-group btn-group-sm" role="group" aria-label="Expand/collapse all">
                                        <button id="btn-expand-all" class="btn btn-light border btn-icon" title="Expand all" type="button">${ICON.chevronBarDown}</button>
                                        <button id="btn-collapse-all" class="btn btn-light border btn-icon" title="Collapse all" type="button">${ICON.chevronBarUp}</button>
                                    </div>
                                    <div class="vr mx-1 align-self-stretch"></div>
                                    <button id="btn-add-root" class="btn btn-primary btn-sm btn-icon" title="Add navigation item">${ICON.plus}</button>
                                </div>
                            </div>
                            <div class="position-relative">
                                <div id="loading-overlay" class="loading-overlay d-none align-items-center justify-content-center">
                                     <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading…</span></div>
                                 </div>
                                 <ul id="nav-root" class="list-unstyled mb-0 d-flex flex-column gap-2"></ul>
                             </div>
                         </div>
                    </div>
                    <div class="col-lg-5" id="right-col" ${sidebarEnabled ? '' : 'hidden'}>
                        <div class="nav-section">
                            <div class="nav-section-header d-flex align-items-center justify-content-between pb-2 mb-2">
                                <span class="fw-semibold d-inline-flex align-items-center gap-2 text-primary">${ICON.braces} <span class="text-body">JSON Preview</span></span>
                                <div class="d-flex gap-2">
                                    <button class="btn btn-sm btn-light border btn-icon" id="btn-copy" title="Copy to clipboard">${ICON.clipboard}</button>
                                    <button id="btn-import" class="btn btn-sm btn-light border btn-icon" title="Import JSON">${ICON.upload}</button>
                                    <input type="file" id="import-file-input" accept="application/json,.json" hidden>
                                    <button id="btn-save" class="btn btn-sm btn-light border btn-icon" title="Download JSON">${ICON.download}</button>
                                </div>
                            </div>
                            <div id="json-preview-body">
                                <pre id="json-preview"></pre>
                            </div>
                        </div>

                        ${this.debugMode ? /*html*/ `<div class="nav-section mt-3" id="schemas-card">
                            <div class="nav-section-header d-flex align-items-center justify-content-between pb-2 mb-2">
                                <span class="fw-semibold d-inline-flex align-items-center gap-2 text-primary">${ICON.braces} <span class="text-body">JSON Schemas</span></span>
                                <ul class="nav nav-pills nav-sm gap-1" role="tablist" id="schema-tabs">
                                    <li class="nav-item"><button type="button" class="nav-link active btn-sm py-1 px-2" data-schema-tab="data">Nav Data</button></li>
                                    <li class="nav-item"><button type="button" class="nav-link btn-sm py-1 px-2" data-schema-tab="template">Template</button></li>
                                </ul>
                                <div class="d-flex gap-2">
                                    <button class="btn btn-sm btn-light border btn-icon" id="btn-schema-copy" title="Copy schema to clipboard">${ICON.clipboard}</button>
                                    <button class="btn btn-sm btn-light border btn-icon" id="btn-schema-download" title="Download schema">${ICON.download}</button>
                                    <a class="btn btn-sm btn-light border btn-icon" id="btn-schema-open" title="Open raw schema" target="_blank" rel="noopener" href="#">${ICON.boxArrow}</a>
                                </div>
                            </div>
                            <div>
                                <pre id="schema-preview" class="mb-2">Loading…</pre>
                                <details>
                                    <summary class="small text-muted">AI prompt snippet</summary>
                                    <pre id="schema-ai-prompt" class="small mt-2 mb-0" style="white-space: pre-wrap;"></pre>
                                </details>
                            </div>
                        </div>` : ''}
                    </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="edit-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content border-0 shadow">
                            <div class="modal-header bg-primary text-white">
                                <h5 class="modal-title d-flex align-items-center gap-2">${ICON.pencil}<span class="modal-title-text">Edit Item</span></h5>
                                <button type="button" class="btn-close btn-close-white" data-dismiss></button>
                            </div>
                            <div class="modal-body">
                                <div class="mb-2">
                                    <label class="form-label d-block">Type</label>
                                    <div class="btn-group w-100" role="group">
                                        <input type="radio" class="btn-check" name="edit-type" id="edit-type-page" value="page" autocomplete="off">
                                        <label class="btn btn-outline-primary" for="edit-type-page">Page</label>
                                        <input type="radio" class="btn-check" name="edit-type" id="edit-type-link" value="link" autocomplete="off">
                                        <label class="btn btn-outline-primary" for="edit-type-link">Link</label>
                                        <input type="radio" class="btn-check" name="edit-type" id="edit-type-label" value="label" autocomplete="off">
                                        <label class="btn btn-outline-primary" for="edit-type-label">Label</label>
                                    </div>
                                    <div class="form-text edit-type-description mt-2 text-center"></div>
                                </div>
                                <div class="mb-3 page-field-group" hidden>
                                    <label class="form-label">Page <span class="text-danger">*</span></label>
                                    <div class="page-picker position-relative">
                                        <div class="page-picker-input-wrap position-relative">
                                            <input type="text" class="form-control edit-page-input" placeholder="Search pages…" autocomplete="off" spellcheck="false">
                                            <button type="button" class="btn-close page-picker-clear" aria-label="Clear selection" hidden></button>
                                        </div>
                                        <div class="page-picker-dropdown list-group shadow-sm" hidden></div>
                                    </div>
                                    <div class="invalid-feedback edit-page-error" hidden>Page is required.</div>
                                    <div class="form-text">Type at least 2 characters to search.</div>
                                    <div class="page-picker-selected small text-muted mt-1" hidden>Selected: <a href="#" class="page-picker-selected-link" target="_blank" rel="noopener"></a></div>
                                </div>
                                <div class="mb-3 url-field-group">
                                    <label class="form-label">URL <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control edit-url" placeholder="e.g. /, /about, https://example.com">
                                    <div class="invalid-feedback">URL is required.</div>
                                    <div class="form-text">Use a relative path (e.g. /about) or a full URL.</div>
                                </div>
                                <div class="mb-3 target-field-group">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input edit-target-blank" type="checkbox" role="switch" id="edit-target-blank">
                                        <label class="form-check-label" for="edit-target-blank">Open in a new tab</label>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <label class="form-label">Title <span class="text-danger">*</span></label>
                                    <input type="text" class="form-control edit-title" placeholder="e.g. Home, About, Contact">
                                    <div class="invalid-feedback">Title is required.</div>
                                </div>
                                <div class="accordion accordion-flush mb-3 advanced-group" id="advanced-accordion">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed advanced-toggle py-2 px-0" type="button" aria-expanded="false">
                                                Advanced
                                            </button>
                                        </h2>
                                        <div class="accordion-collapse collapse advanced-body">
                                            <div class="accordion-body pt-1 pb-2 px-0">
                                                <div class="form-text mb-2">Optional hooks for custom theming or scripting. Leave blank if unsure.</div>
                                                <div class="row g-2">
                                                    <div class="col-6">
                                                        <label class="form-label">ID</label>
                                                        <input type="text" class="form-control edit-nav-id" placeholder="Optional unique identifier">
                                                    </div>
                                                    <div class="col-6">
                                                        <label class="form-label">CSS Class</label>
                                                        <input type="text" class="form-control edit-css-class" placeholder="Optional CSS class(es)">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-1 d-flex flex-column gap-2 align-items-start">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input edit-visible" type="checkbox" role="switch" id="edit-visible" checked>
                                        <label class="form-check-label" for="edit-visible">Visible</label>
                                    </div>
                                    <div class="form-check form-switch match-this-url-group" title="Highlight this item as active only when the current URL matches its URL.">
                                        <input class="form-check-input edit-match-this-url" type="checkbox" role="switch" id="edit-match-this-url">
                                        <label class="form-check-label" for="edit-match-this-url">Match this URL</label>
                                    </div>
                                    <div class="form-check form-switch hide-children-in-parent-group" title="Applies once this item has child items.">
                                        <input class="form-check-input edit-hide-children-in-parent" type="checkbox" role="switch" id="edit-hide-children-in-parent">
                                        <label class="form-check-label" for="edit-hide-children-in-parent">Hide my children on parent items</label>
                                        <div class="form-text hide-children-in-parent-hint" hidden>Applies once this item has child items.</div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer bg-light">
                                <button type="button" class="btn btn-light" data-dismiss>Cancel</button>
                                <button type="button" class="btn btn-primary px-4 btn-save-edit d-inline-flex align-items-center gap-1">Update</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="delete-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-sm">
                        <div class="modal-content border-0 shadow">
                            <div class="modal-header bg-danger text-white">
                                <h5 class="modal-title d-flex align-items-center gap-2">${ICON.exclamation} Delete Item</h5>
                                <button type="button" class="btn-close btn-close-white" data-dismiss></button>
                            </div>
                            <div class="modal-body">
                                <p class="mb-0">Delete <strong class="delete-item-name"></strong>?
                                    <span class="text-muted d-block mt-1 small">All child items will also be removed.</span></p>
                            </div>
                            <div class="modal-footer bg-light">
                                <button type="button" class="btn btn-sm btn-light" data-dismiss>Cancel</button>
                                <button type="button" class="btn btn-sm btn-danger px-3 btn-confirm-delete d-inline-flex align-items-center gap-1">${ICON.trash} Delete</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;

        this.rootUl = this.shadow.getElementById('nav-root') as HTMLUListElement;
        this.itemCountEl = this.shadow.getElementById('item-count')!;
        this.jsonPreviewEl = this.shadow.getElementById('json-preview')!;

        this.shadow.getElementById('btn-add-root')!.addEventListener('click', () => this.addRootItem());
        this.shadow.getElementById('btn-save-server')!.addEventListener('click', () => this.saveToServer());
        this.shadow.getElementById('btn-expand-all')!.addEventListener('click', () => this.setAllCollapsed(false));
        this.shadow.getElementById('btn-collapse-all')!.addEventListener('click', () => this.setAllCollapsed(true));
        this.wireFilter();

        const advancedToggle = this.shadow.getElementById('toggle-advanced') as HTMLInputElement | null;
        advancedToggle?.addEventListener('change', () => this.setAdvancedMode(advancedToggle.checked));
        const sidebarToggle = this.shadow.getElementById('btn-toggle-sidebar');
        sidebarToggle?.addEventListener('click', () => this.toggleSidebar());

        // JSON Preview card is always in the DOM; wire its buttons unconditionally.
        this.shadow.getElementById('btn-save')!.addEventListener('click', () => this.saveAndDownload());
        this.shadow.getElementById('btn-copy')!.addEventListener('click', () => this.copyJson());
        const importBtn = this.shadow.getElementById('btn-import')!;
        const importInput = this.shadow.getElementById('import-file-input') as HTMLInputElement;
        importBtn.addEventListener('click', () => importInput.click());
        importInput.addEventListener('change', () => this.handleImportFile(importInput));

        if (this.debugMode) {
            this.initSchemasPanel();
        }

        this.renderTree();
    }

    protected onInit(): void {
        this.wireModals();
        this.initAllSortables();
        this.updatePreview();
        document.addEventListener('keydown', this.onKeydown);
        void this.loadFromServer();
    }

    // ── Server sync ───────────────────────────────────────────────────
    private async loadFromServer(): Promise<void> {
        const endpoint = (this.config as any).navigationUrl as string | undefined;
        if (endpoint) navigationService.setEndpoint(endpoint);
        this.setLoading(true);
        try {
            const schema = await navigationService.get();
            if (Array.isArray(schema) && schema.length) this.setSchema(schema);
        } catch (err) {
            console.error('Failed to load navigation:', err);
            this.toast.error('Could not load navigation: ' + ((err as Error)?.message || 'unknown error'), { title: 'Load failed' });
        } finally {
            this.setLoading(false);
        }
    }

    private setLoading(loading: boolean): void {
        const overlay = this.shadow.getElementById('loading-overlay');
        if (!overlay) return;
        overlay.classList.toggle('d-none', !loading);
        overlay.classList.toggle('d-flex', loading);
    }

    private async saveToServer(): Promise<void> {
        this.syncFromDom();
        const schema = this.buildSchema();
        const btn = this.shadow.getElementById('btn-save-server') as HTMLButtonElement | null;
        if (btn) btn.disabled = true;
        this.setSaveStatus('saving');
        this.setLoading(true);
        try {
            await navigationService.save(schema);
            this.dispatchEvent(new CustomEvent('eum-nav-saved', {
                bubbles: true, composed: true, detail: schema,
            }));
            this.setSaveStatus('saved');
        } catch (err) {
            console.error('Failed to save navigation:', err);
            this.setSaveStatus('failed');
            this.toast.error('Could not save navigation: ' + ((err as Error)?.message || 'unknown error'), { title: 'Save failed' });
        } finally {
            if (btn) btn.disabled = false;
            this.setLoading(false);
        }
    }

    protected onStateChange(_state: SearchState, _changedKey: keyof SearchState): void {
        // No search UI wired up yet — nav tree rendering is driven by our
        // own methods rather than base-class state changes.
    }

    disconnectedCallback(): void {
        super.disconnectedCallback();
        if (this.rootUl) this.destroyAllSortables(this.rootUl);
        this.resetPagePicker();
        document.removeEventListener('keydown', this.onKeydown);
        this.backdropEl?.remove();
        this.backdropEl = null;
        this.openModalEl = null;
    }

    // ── Public API ────────────────────────────────────────────────────
    public getSchema(): NavSchema {
        return this.buildSchema();
    }

    public setSchema(schema: NavSchema): void {
        this.navItems = this.normalizeItems((schema || []) as any);
        this.renderTree();
        this.updatePreview();
    }

    // ── Rendering ─────────────────────────────────────────────────────
    private normalizeItems(items: any[]): NavItem[] {
        return items.map((it) => {
            const type: NavItem['type'] = it.type === 'label' || it.type === 'page' ? it.type : 'link';
            const isLabel = type === 'label';
            return {
                id: this.genId(),
                type,
                title: it.title || '',
                url: isLabel ? null : (it.url || ''),
                target: isLabel ? null : (it.target || '_self'),
                visible: it.visible !== false,
                children: this.normalizeItems(it.children || []),
                pageId: type === 'page' ? (it.pageId || null) : null,
                navId: it.id ?? it.navId ?? null,
                cssClass: it.cssClass ?? null,
                collapsed: it.collapsed === true,
                hideChildrenInParent: it.hideChildrenInParent === true,
                matchThisURL: it.matchThisURL === true,
            };
        });
    }

    private renderTree(): void {
        if (this.rootUl) this.destroyAllSortables(this.rootUl);
        this.rootUl.innerHTML = '';
        const items = this.filterId ? this.buildFilteredTree(this.navItems, this.filterId) : this.navItems;
        items.forEach((item, idx) =>
            this.rootUl.appendChild(this.createItemEl(item, { isRoot: true, hasPrevSibling: idx > 0 }))
        );
        this.initAllSortables();
    }

    private buildFilteredTree(items: NavItem[], targetId: string): NavItem[] {
        const result: NavItem[] = [];
        for (const it of items) {
            if (it.id === targetId) {
                result.push(it);
            } else if (it.children?.length) {
                const childMatches = this.buildFilteredTree(it.children, targetId);
                if (childMatches.length) {
                    result.push({ ...it, children: childMatches });
                }
            }
        }
        return result;
    }

    private createItemEl(item: NavItem, opts: { isRoot: boolean; hasPrevSibling: boolean }): HTMLLIElement {
        const li = document.createElement('li');
        li.className = 'nav-item-li';
        li.dataset.id = item.id;

        const isLabel = item.type === 'label';
        const isPage = item.type === 'page';
        const isExternal = !isLabel && this.isExternalUrl(item.url);

        const typeBadgeText = isLabel ? 'Label' : (isPage ? 'Page' : 'Link');
        const typeBadgeIcon = isLabel ? ICON.tag : (isPage ? ICON.file : ICON.boxArrow);
        const typeBadgeColor = isLabel ? 'background:#fd7e14' : (isPage ? 'background:#20c997' : 'background:#0d6efd');
        const typeBadge = `<span class="badge badge-mini nav-type-badge text-white" style="${typeBadgeColor}">${typeBadgeIcon} ${typeBadgeText}</span>`;

        const targetBadge = (!isLabel && item.target === '_blank')
            ? `<span class="badge bg-info text-dark ms-1 badge-mini">${ICON.windowPlus} new tab</span>` : '';
        const externalBadge = isExternal
            ? `<span class="badge bg-warning text-dark ms-1 badge-mini">${ICON.boxArrow} external</span>` : '';
        const hiddenBadge = !item.visible
            ? `<span class="badge bg-white text-dark ms-1 border badge-mini">${ICON.eyeSlash} hidden</span>` : '';
        const childCount = item.children?.length ?? 0;
        const hasChildBadge = childCount > 0
            ? `<span class="badge bg-secondary ms-1 badge-mini">${ICON.diagram} ${childCount} child${childCount !== 1 ? 'ren' : ''}</span>` : '';

        const urlLine = !isLabel
            ? `<span class="small" title="${this.escapeHTML(item.url || '')}">${this.escapeHTML(item.url || '')}</span>` : '';

        const row = document.createElement('div');
        row.className = `nav-item-row d-flex align-items-center gap-2 p-2 border rounded item-type-${item.type}`;
        row.innerHTML = /*html*/ `
            <span class="drag-handle" title="Drag to reorder">${ICON.gripVertical}</span>
            <div class="flex-grow-1 overflow-hidden lh-sm drag-handle" title="Drag to reorder ">
                <div class="d-flex align-items-center flex-wrap gap-1">
                    <span class="small fw-semibold${isLabel ? ' item-label-text' : ''}">${this.escapeHTML(item.title)}</span>
                    ${(item.navId || item.cssClass) ? `<span class="text-body-secondary fst-italic small ms-1">(${[item.navId ? '#' + item.navId : '', item.cssClass ? '.' + item.cssClass.replace(/\s+/g, ' .') : ''].filter(Boolean).map((s) => this.escapeHTML(s)).join(' ')})</span>` : ''}
                    ${hiddenBadge}${externalBadge}${targetBadge}${hasChildBadge}
                </div>
                <div class="small text-body-tertiary fst-italic">${urlLine}</div>
            </div>  
            ${typeBadge}
            <button class="btn btn-icon btn-outline-secondary border-0 btn-outdent${opts.isRoot ? ' disabled' : ''}"
                    title="Promote: move up one level" type="button" ${opts.isRoot ? 'disabled' : ''}>${ICON.arrowLeft}</button>
            <button class="btn btn-icon btn-outline-secondary border-0 btn-indent${!opts.hasPrevSibling ? ' disabled' : ''}"
                    title="Demote: nest under previous item" type="button" ${!opts.hasPrevSibling ? 'disabled' : ''}>${ICON.arrowRight}</button>
            <div class="vr mx-1 my-2"></div>
            <button class="btn btn-icon btn-outline-primary border-0 btn-edit" title="Edit item" type="button">${ICON.pencil}</button>
            <button class="btn btn-icon btn-outline-success border-0 btn-add-child" title="Add child item" type="button">${ICON.nodePlus}</button>
            <button class="btn btn-icon btn-outline-secondary border-0 btn-duplicate" title="Duplicate item" type="button">${ICON.copy}</button>
            <button class="btn btn-icon btn-outline-danger border-0 btn-delete" title="Delete item" type="button">${ICON.trash}</button>
            ${childCount > 0 ? `<div class="vr mx-1 my-2"></div><button class="btn btn-icon btn-outline-secondary border-0 btn-toggle-children" title="${item.collapsed ? 'Expand' : 'Collapse'} children" type="button">${item.collapsed ? ICON.arrowDown : ICON.chevronUp}</button>` : ''}
        `; 

        row.querySelector('.btn-outdent')!.addEventListener('click', () => this.promoteItem(item.id));
        row.querySelector('.btn-indent')!.addEventListener('click', () => this.demoteItem(item.id));
        row.querySelector('.btn-edit')!.addEventListener('click', () => this.openEditModal(item.id, false));
        row.querySelector('.btn-add-child')!.addEventListener('click', () => this.addChildItem(item.id));
        row.querySelector('.btn-duplicate')!.addEventListener('click', () => this.duplicateItem(item.id));
        row.querySelector('.btn-delete')!.addEventListener('click', () => this.openDeleteModal(item.id));
        const toggleBtn = row.querySelector('.btn-toggle-children');
        if (toggleBtn) toggleBtn.addEventListener('click', () => this.toggleCollapsed(item.id));

        const childUl = document.createElement('ul');
        childUl.className = 'nav-children list-unstyled mb-0';
        if (item.collapsed) childUl.hidden = true;
        item.children.forEach((child, idx) =>
            childUl.appendChild(this.createItemEl(child, { isRoot: false, hasPrevSibling: idx > 0 }))
        );

        li.appendChild(row);
        li.appendChild(childUl);
        return li;
    }

    // ── Modals ────────────────────────────────────────────────────────
    private wireModals(): void {
        this.editModalEl = this.shadow.getElementById('edit-modal') as HTMLElement;
        this.deleteModalEl = this.shadow.getElementById('delete-modal') as HTMLElement;

        // Dismiss on backdrop click or any [data-dismiss] element.
        [this.editModalEl, this.deleteModalEl].forEach((modal) => {
            modal.addEventListener('click', (e) => {
                const target = e.target as HTMLElement;
                if (target.closest('[data-dismiss]')) { this.hideModal(modal); return; }
                if (target === modal && modal.getAttribute('data-bs-backdrop') !== 'static') this.hideModal(modal);
            });
        });

        this.editModalEl.querySelector('.btn-save-edit')!.addEventListener('click', () => this.saveEdit());
        (['edit-title', 'edit-url'] as const).forEach((cls) => {
            this.editModalEl.querySelector('.' + cls)!.addEventListener('keydown', (e) => {
                if ((e as KeyboardEvent).key === 'Enter') { e.preventDefault(); this.saveEdit(); }
            });
        });
        this.editModalEl.querySelectorAll('input[name="edit-type"]').forEach((radio) => {
            radio.addEventListener('change', (e) => {
                const val = (e.target as HTMLInputElement).value as 'link' | 'label' | 'page';
                this.applyTypeVisibility(val);
                const focusSelector = val === 'page' ? '.edit-page-input'
                    : val === 'link' ? '.edit-url'
                        : '.edit-title';
                (this.editModalEl.querySelector(focusSelector) as HTMLInputElement).focus();
            });
        });

        this.wirePagePicker();

        const idInput = this.editModalEl.querySelector('.edit-nav-id') as HTMLInputElement;
        idInput.addEventListener('input', () => {
            const clean = this.sanitizeId(idInput.value);
            if (idInput.value !== clean) idInput.value = clean;
        });
        const cssInput = this.editModalEl.querySelector('.edit-css-class') as HTMLInputElement;
        cssInput.addEventListener('blur', () => {
            const clean = this.sanitizeCssClass(cssInput.value);
            if (cssInput.value !== clean) cssInput.value = clean;
        });
        cssInput.addEventListener('input', () => {
            // Strip disallowed chars but preserve trailing space while typing multi-class values.
            const clean = cssInput.value.replace(/[^A-Za-z0-9_\-\s]/g, '');
            if (cssInput.value !== clean) cssInput.value = clean;
        });

        this.deleteModalEl.querySelector('.btn-confirm-delete')!.addEventListener('click', () => this.confirmDelete());

        const advToggle = this.editModalEl.querySelector('.advanced-toggle') as HTMLButtonElement;
        advToggle.addEventListener('click', () => {
            const body = this.editModalEl.querySelector('.advanced-body') as HTMLElement;
            this.setAdvancedOpen(!body.classList.contains('show'));
        });
    }

    private setAdvancedOpen(open: boolean): void {
        const btn = this.editModalEl.querySelector('.advanced-toggle') as HTMLButtonElement;
        const body = this.editModalEl.querySelector('.advanced-body') as HTMLElement;
        btn.classList.toggle('collapsed', !open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        body.classList.toggle('show', open);
    }

    private showModal(modal: HTMLElement): void {
        if (this.openModalEl && this.openModalEl !== modal) this.hideModal(this.openModalEl);
        if (!this.backdropEl) {
            this.backdropEl = document.createElement('div');
            this.backdropEl.className = 'modal-backdrop fade';
            this.shadow.appendChild(this.backdropEl);
        }
        modal.style.display = 'block';
        modal.removeAttribute('aria-hidden');
        modal.setAttribute('aria-modal', 'true');
        // Force reflow so the .show transition applies.
        void modal.offsetWidth;
        modal.classList.add('show');
        this.backdropEl.classList.add('show');
        this.openModalEl = modal;
    }

    private hideModal(modal: HTMLElement): void {
        modal.classList.remove('show');
        modal.setAttribute('aria-hidden', 'true');
        modal.removeAttribute('aria-modal');
        modal.style.display = 'none';
        this.backdropEl?.remove();
        this.backdropEl = null;
        this.openModalEl = null;

        if (modal === this.editModalEl) {
            if (this.isNewItem) this.pendingNewItem = null;
            this.editingId = null;
            this.isNewItem = false;
            this.resetPagePicker();
            this.selectedPage = null;
        }
    }

    // ── Page picker (EUM Search) ─────────────────────────
    private applyTypeVisibility(type: 'link' | 'label' | 'page'): void {
        const el = this.editModalEl;
        const isLink = type === 'link';
        const isPage = type === 'page';
        const isLinkOrPage = isLink || isPage;
        (el.querySelector('.url-field-group') as HTMLElement).hidden = !isLink;
        (el.querySelector('.page-field-group') as HTMLElement).hidden = !isPage;
        (el.querySelector('.target-field-group') as HTMLElement).hidden = !isLinkOrPage;
        if (!isLink) (el.querySelector('.edit-url') as HTMLElement).classList.remove('is-invalid');
        if (!isLinkOrPage) (el.querySelector('.edit-target-blank') as HTMLInputElement).checked = false;
        if (!isPage) (el.querySelector('.edit-page-error') as HTMLElement).hidden = true;

        const hideChildrenGroup = el.querySelector('.hide-children-in-parent-group') as HTMLElement | null;
        if (hideChildrenGroup) {
            const isLabel = type === 'label';
            hideChildrenGroup.hidden = isLabel;
            if (isLabel) {
                (el.querySelector('.edit-hide-children-in-parent') as HTMLInputElement).checked = false;
            }
        }

        const matchThisUrlGroup = el.querySelector('.match-this-url-group') as HTMLElement | null;
        if (matchThisUrlGroup) {
            const isLabel = type === 'label';
            matchThisUrlGroup.hidden = isLabel;
            if (isLabel) {
                (el.querySelector('.edit-match-this-url') as HTMLInputElement).checked = false;
            }
        }

        const descEl = el.querySelector('.edit-type-description') as HTMLElement | null;
        if (descEl) {
            descEl.textContent = isPage
                ? 'Links to a page within this portal, selected from search.'
                : isLink
                    ? 'Links to any custom URL — internal path or external site.'
                    : 'A non-clickable heading used to group child items.';
        }
    }

    private wirePagePicker(): void {
        if (this.pagePickerWired) return;
        this.pagePickerWired = true;
        const input = this.editModalEl.querySelector('.edit-page-input') as HTMLInputElement;
        const dropdown = this.editModalEl.querySelector('.page-picker-dropdown') as HTMLElement;

        input.addEventListener('input', () => {
            // Typing invalidates the current selection.
            if (this.selectedPage && input.value !== this.selectedPage.title) {
                this.selectedPage = null;
                this.updatePagePickerSelectedText();
            }
            this.updatePagePickerClearButton();
            this.schedulePageSearch(input.value);
        });
        input.addEventListener('focus', () => {
            if (input.value.trim().length >= 2) this.showPageDropdown();
        });
        input.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') { this.hidePageDropdown(); return; }
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                this.movePageDropdownActive(e.key === 'ArrowDown' ? 1 : -1);
            } else if (e.key === 'Enter') {
                const active = dropdown.querySelector('.active') as HTMLElement | null;
                if (active && !dropdown.hidden) {
                    e.preventDefault();
                    active.click();
                }
            }
        });
        // Click outside inside the shadow root closes the dropdown.
        this.editModalEl.addEventListener('mousedown', (e) => {
            const t = e.target as HTMLElement;
            if (!t.closest('.page-picker')) this.hidePageDropdown();
        });

        (this.editModalEl.querySelector('.page-picker-clear') as HTMLElement).addEventListener('click', () => {
            this.clearPageSelection();
            input.focus();
        });
    }

    private clearPageSelection(): void {
        this.selectedPage = null;
        const input = this.editModalEl.querySelector('.edit-page-input') as HTMLInputElement;
        input.value = '';
        this.updatePagePickerSelectedText();
        this.updatePagePickerClearButton();
        this.renderPageResults([]);
        this.hidePageDropdown();
    }

    private updatePagePickerClearButton(): void {
        const btn = this.editModalEl.querySelector('.page-picker-clear') as HTMLElement;
        const input = this.editModalEl.querySelector('.edit-page-input') as HTMLInputElement;
        btn.hidden = !(this.selectedPage || (input.value?.length ?? 0) > 0);
    }

    private movePageDropdownActive(delta: number): void {
        const dropdown = this.editModalEl.querySelector('.page-picker-dropdown') as HTMLElement;
        if (dropdown.hidden) { this.showPageDropdown(); }
        const items = Array.from(dropdown.querySelectorAll('.list-group-item')) as HTMLElement[];
        if (!items.length) return;
        const currentIdx = items.findIndex((i) => i.classList.contains('active'));
        let next = currentIdx + delta;
        if (next < 0) next = items.length - 1;
        if (next >= items.length) next = 0;
        items.forEach((i) => i.classList.remove('active'));
        items[next].classList.add('active');
        items[next].scrollIntoView({ block: 'nearest' });
    }

    private showPageDropdown(): void {
        (this.editModalEl.querySelector('.page-picker-dropdown') as HTMLElement).hidden = false;
    }

    private hidePageDropdown(): void {
        (this.editModalEl.querySelector('.page-picker-dropdown') as HTMLElement).hidden = true;
    }

    private updatePagePickerSelectedText(): void {
        const el = this.editModalEl.querySelector('.page-picker-selected') as HTMLElement;
        const link = el.querySelector('.page-picker-selected-link') as HTMLAnchorElement;
        if (this.selectedPage) {
            link.textContent = this.selectedPage.url;
            link.href = this.selectedPage.url || '#';
            el.hidden = false;
        } else {
            link.textContent = '';
            link.removeAttribute('href');
            el.hidden = true;
        }
    }

    private resetPagePicker(): void {
        if (this.pageSearchTimer) { clearTimeout(this.pageSearchTimer); this.pageSearchTimer = null; }
        this.pageSearchAbort?.abort();
        this.pageSearchAbort = null;
        const input = this.editModalEl?.querySelector('.edit-page-input') as HTMLInputElement | null;
        const dropdown = this.editModalEl?.querySelector('.page-picker-dropdown') as HTMLElement | null;
        if (input) input.value = '';
        if (dropdown) { dropdown.innerHTML = ''; dropdown.hidden = true; }
        this.updatePagePickerSelectedText();
        this.updatePagePickerClearButton();
    }

    private primePagePicker(): void {
        const input = this.editModalEl.querySelector('.edit-page-input') as HTMLInputElement;
        if (this.selectedPage) {
            input.value = this.selectedPage.title;
        } else {
            input.value = '';
        }
        this.updatePagePickerSelectedText();
        this.updatePagePickerClearButton();
        this.hidePageDropdown();
    }

    private schedulePageSearch(text: string): void {
        if (this.pageSearchTimer) { clearTimeout(this.pageSearchTimer); this.pageSearchTimer = null; }
        const trimmed = text.trim();
        if (trimmed.length < 2) {
            this.renderPageResults([]);
            this.hidePageDropdown();
            return;
        }
        this.pageSearchTimer = window.setTimeout(() => this.runPageSearch(trimmed), 200);
    }

    private renderPageResults(items: Array<{ id: string; url: string; title: string }>): void {
        const dropdown = this.editModalEl.querySelector('.page-picker-dropdown') as HTMLElement;
        dropdown.innerHTML = '';
        if (!items.length) {
            const empty = document.createElement('div');
            empty.className = 'list-group-item text-muted small';
            empty.textContent = 'No pages found';
            dropdown.appendChild(empty);
            return;
        }
        items.forEach((it) => {
            const row = document.createElement('button');
            row.type = 'button';
            row.className = 'list-group-item list-group-item-action';
            row.innerHTML = `<div class="fw-semibold">${this.escapeHTML(it.title)}</div><div class="text-muted page-picker-url">${this.escapeHTML(it.url)}</div>`;
            row.addEventListener('click', () => this.selectPageResult(it));
            dropdown.appendChild(row);
        });
    }

    private selectPageResult(it: { id: string; url: string; title: string }): void {
        this.selectedPage = { id: it.id, url: it.url, title: it.title };
        const input = this.editModalEl.querySelector('.edit-page-input') as HTMLInputElement;
        input.value = it.title;
        input.classList.remove('is-invalid');
        this.updatePagePickerSelectedText();
        this.updatePagePickerClearButton();
        this.hidePageDropdown();
        const titleEl = this.editModalEl.querySelector('.edit-title') as HTMLInputElement;
        titleEl.value = it.title;
        titleEl.classList.remove('is-invalid');
        (this.editModalEl.querySelector('.edit-page-error') as HTMLElement).hidden = true;
    }

    private async runPageSearch(text: string): Promise<void> {
        this.pageSearchAbort?.abort();
        this.pageSearchAbort = new AbortController();

        const baseFilter = (this.config.filter as string) || "EUMSearchSource eq 'Publisher Pages' and not search.ismatch('/Shared', 'RelativeURL') and search.in(SiteURL,'{currentSite}')";
        const url = (this.config.url as string) || this.searchUrl;

        try {
            const results = await searchService.search(url, text, {
                searchOptions: { filter: baseFilter, size: 25, skip: 0, includeTotalCount: false },
                Select: ['id', 'Title', 'RelativeURL']
            });
            const items = (results.value || []).map((r) => {
                const doc: any = r.document || {};
                const pageUrl = String(doc.RelativeURL ?? '');
                const id = String(doc.Id ?? doc.id ?? doc.DocumentId ?? pageUrl);
                const title = String(doc.Title ?? doc.Name ?? pageUrl);
                return { id, url: pageUrl, title };
            });
            this.renderPageResults(items);
            this.showPageDropdown();
        } catch (err) {
            if ((err as any)?.name === 'AbortError') return;
            console.error('Page search failed:', err);
        }
    }

    // ── Actions ───────────────────────────────────────────────────────
    private addRootItem(): void {
        const item = this.blankItem();
        this.pendingNewItem = { item, parentId: null };
        this.openEditModal(item.id, true);
    }

    private addChildItem(parentId: string): void {
        this.syncFromDom();
        const item = this.blankItem();
        this.pendingNewItem = { item, parentId };
        this.openEditModal(item.id, true);
    }

    private blankItem(): NavItem {
        return { id: this.genId(), type: 'page', title: '', url: '', target: '_self', visible: true, children: [], pageId: null, navId: null, cssClass: null, hideChildrenInParent: false, matchThisURL: false };
    }

    private openEditModal(id: string, isNew: boolean): void {
        this.isNewItem = isNew;
        this.editingId = id;

        let item: NavItem | null | undefined;
        if (isNew) {
            item = this.pendingNewItem?.item;
        } else {
            this.syncFromDom();
            item = this.findById(this.navItems, id);
        }
        if (!item) return;

        const el = this.editModalEl;
        (el.querySelector('.modal-title-text') as HTMLElement).textContent = isNew ? 'New Item' : 'Edit Item';
        (el.querySelector('.btn-save-edit') as HTMLElement).textContent = isNew ? 'Add' : 'Update';
        const itemType = (item.type || 'link') as 'link' | 'label' | 'page';
        (el.querySelector(`input[value="${itemType}"]`) as HTMLInputElement).checked = true;
        (el.querySelector('.edit-title') as HTMLInputElement).value = item.title || '';
        (el.querySelector('.edit-url') as HTMLInputElement).value = item.url || '';
        (el.querySelector('.edit-target-blank') as HTMLInputElement).checked = item.target === '_blank';
        (el.querySelector('.edit-nav-id') as HTMLInputElement).value = item.navId || '';
        (el.querySelector('.edit-css-class') as HTMLInputElement).value = item.cssClass || '';
        const hideChildrenEl = el.querySelector('.edit-hide-children-in-parent') as HTMLInputElement;
        const hasChildren = (item.children?.length ?? 0) > 0;
        hideChildrenEl.checked = item.hideChildrenInParent === true;
        hideChildrenEl.disabled = !hasChildren;
        (el.querySelector('.hide-children-in-parent-hint') as HTMLElement).hidden = hasChildren;
        (el.querySelector('.edit-match-this-url') as HTMLInputElement).checked = item.matchThisURL === true;
        this.setAdvancedOpen(!!(item.navId || item.cssClass));
        (el.querySelector('.edit-visible') as HTMLInputElement).checked = item.visible !== false;

        // Reset any prior page selection / picker state.
        this.resetPagePicker();
        this.selectedPage = (itemType === 'page' && item.pageId)
            ? { id: item.pageId, url: item.url || '', title: item.title || '' }
            : null;

        this.applyTypeVisibility(itemType);

        el.querySelectorAll('.is-invalid').forEach((n) => n.classList.remove('is-invalid'));
        (el.querySelector('.edit-page-error') as HTMLElement).hidden = true;

        this.showModal(el);
        if (itemType === 'page') this.primePagePicker();
        const focusSelector = itemType === 'page' ? '.edit-page-input'
            : itemType === 'link' ? '.edit-url'
                : '.edit-title';
        (el.querySelector(focusSelector) as HTMLInputElement).focus();
    }

    private saveEdit(): void {
        const el = this.editModalEl;
        const titleEl = el.querySelector('.edit-title') as HTMLInputElement;
        const urlEl = el.querySelector('.edit-url') as HTMLInputElement;
        const typeVal = (el.querySelector('input[name="edit-type"]:checked') as HTMLInputElement).value as 'link' | 'label' | 'page';
        const title = titleEl.value.trim();
        const url = urlEl.value.trim();
        const isLink = typeVal === 'link';
        const isPage = typeVal === 'page';

        titleEl.classList.toggle('is-invalid', !title);
        urlEl.classList.toggle('is-invalid', isLink && !url);
        const pageInput = el.querySelector('.edit-page-input') as HTMLInputElement;
        const pageErr = el.querySelector('.edit-page-error') as HTMLElement;
        const pageInvalid = isPage && !this.selectedPage;
        pageInput.classList.toggle('is-invalid', pageInvalid);
        pageErr.hidden = !pageInvalid;
        if (!title || (isLink && !url) || pageInvalid) return;

        const visible = (el.querySelector('.edit-visible') as HTMLInputElement).checked;
        const navId = this.sanitizeId((el.querySelector('.edit-nav-id') as HTMLInputElement).value) || null;
        const cssClass = this.sanitizeCssClass((el.querySelector('.edit-css-class') as HTMLInputElement).value) || null;
        const hideChildrenInParent = typeVal === 'label'
            ? false
            : (el.querySelector('.edit-hide-children-in-parent') as HTMLInputElement).checked;
        const matchThisURL = typeVal === 'label'
            ? false
            : (el.querySelector('.edit-match-this-url') as HTMLInputElement).checked;
        const isLinkOrPage = isLink || isPage;
        const target = isLinkOrPage ? ((el.querySelector('.edit-target-blank') as HTMLInputElement).checked ? '_blank' : '_self') : null;
        const finalUrl = isPage ? (this.selectedPage?.url || '') : (isLink ? url : null);
        const pageId = isPage ? (this.selectedPage?.id || null) : null;

        const apply = (item: NavItem) => {
            item.type = typeVal;
            item.title = title;
            item.url = finalUrl;
            item.target = target as any;
            item.visible = visible;
            item.pageId = pageId;
            item.navId = navId;
            item.cssClass = cssClass;
            item.hideChildrenInParent = hideChildrenInParent;
            item.matchThisURL = matchThisURL;
        };

        if (this.isNewItem && this.pendingNewItem) {
            const { item, parentId } = this.pendingNewItem;
            apply(item);
            if (parentId === null) {
                this.navItems.push(item);
            } else {
                const parent = this.findById(this.navItems, parentId);
                if (parent) parent.children.push(item);
            }
            this.pendingNewItem = null;
        } else {
            const item = this.findById(this.navItems, this.editingId!);
            if (item) apply(item);
        }

        this.hideModal(this.editModalEl);
        this.renderTree();
        this.updatePreview();
        this.fireChange();
    }

    private openDeleteModal(id: string): void {
        this.syncFromDom();
        this.deletingId = id;
        const item = this.findById(this.navItems, id);
        (this.deleteModalEl.querySelector('.delete-item-name') as HTMLElement).textContent = item?.title ?? 'this item';
        this.showModal(this.deleteModalEl);
    }

    private confirmDelete(): void {
        if (this.deletingId) {
            this.removeById(this.navItems, this.deletingId);
            this.deletingId = null;
        }
        this.hideModal(this.deleteModalEl);
        this.renderTree();
        this.updatePreview();
        this.fireChange();
    }

    // ── Promote / Demote ──────────────────────────────────────────────
    private promoteItem(id: string): void {
        this.syncFromDom();
        const ctx = this.findParentContext(this.navItems, id);
        if (!ctx || !ctx.parentItem) return;
        const parentCtx = this.findParentContext(this.navItems, ctx.parentItem.id);
        const grandSiblings = parentCtx ? parentCtx.siblings : this.navItems;
        const parentIndex = grandSiblings.findIndex((i) => i.id === ctx.parentItem!.id);
        ctx.siblings.splice(ctx.index, 1);
        grandSiblings.splice(parentIndex + 1, 0, ctx.item);
        this.renderTree();
        this.updatePreview();
        this.fireChange();
    }

    private demoteItem(id: string): void {
        this.syncFromDom();
        const ctx = this.findParentContext(this.navItems, id);
        if (!ctx || ctx.index === 0) return;
        const prevSibling = ctx.siblings[ctx.index - 1];
        ctx.siblings.splice(ctx.index, 1);
        prevSibling.children.push(ctx.item);
        prevSibling.collapsed = false;
        this.renderTree();
        this.updatePreview();
        this.fireChange();
    }

    private toggleCollapsed(id: string): void {
        this.syncFromDom();
        const item = this.findById(this.navItems, id);
        if (!item || !item.children?.length) return;
        item.collapsed = !item.collapsed;
        this.renderTree();
    }

    private duplicateItem(id: string): void {
        this.syncFromDom();
        const ctx = this.findParentContext(this.navItems, id);
        if (!ctx) return;
        const clone = this.cloneItem(ctx.item);
        ctx.siblings.splice(ctx.index + 1, 0, clone);
        this.renderTree();
        this.updatePreview();
        this.fireChange();
    }

    private cloneItem(item: NavItem): NavItem {
        return {
            ...item,
            id: this.genId(),
            navId: null,
            children: (item.children || []).map((c) => this.cloneItem(c)),
        };
    }

    // ── DOM ↔ Data sync ───────────────────────────────────────────────
    private domToTree(ul: HTMLElement): NavItem[] {
        const result: NavItem[] = [];
        ul.querySelectorAll(':scope > li[data-id]').forEach((li) => {
            const id = (li as HTMLElement).dataset.id!;
            const item = this.findById(this.navItems, id);
            if (!item) return;
            const childUl = li.querySelector(':scope > ul.nav-children') as HTMLElement | null;
            const children = childUl ? this.domToTree(childUl) : [];
            result.push({ ...item, children });
        });
        return result;
    }

    private syncFromDom(): void {
        if (this.filterId) return; // DOM only contains a subset while filtered
        if (this.rootUl) this.navItems = this.domToTree(this.rootUl);
    }

    // ── Sortable ──────────────────────────────────────────────────────
    private makeSortable(ul: HTMLElement): any {
        const instance = new Sortable(ul, {
            group: { name: 'eum-nested-nav', pull: true, put: true },
            animation: 150,
            handle: '.drag-handle',
            fallbackOnBody: true,
            swapThreshold: 0.65,
            emptyInsertThreshold: 8,
            ghostClass: 'sortable-ghost',
            chosenClass: 'sortable-chosen',
            dragClass: 'sortable-drag',
            onEnd: () => {
                this.syncFromDom();
                this.renderTree();
                this.updatePreview();
                this.fireChange();
            },
        });
        this.sortableInstances.set(ul, instance);
        return instance;
    }

    private destroyAllSortables(root: HTMLElement): void {
        [root, ...Array.from(root.querySelectorAll('ul.nav-children'))].forEach((ul) => {
            const inst = this.sortableInstances.get(ul as HTMLElement);
            if (inst) { inst.destroy(); this.sortableInstances.delete(ul as HTMLElement); }
        });
    }

    private initAllSortables(): void {
        [this.rootUl, ...Array.from(this.rootUl.querySelectorAll('ul.nav-children'))].forEach((ul) => {
            if (!this.sortableInstances.has(ul as HTMLElement)) this.makeSortable(ul as HTMLElement);
        });
    }

    // ── Schema / preview ──────────────────────────────────────────────
    private buildSchema(): NavSchema {
        const clean = (items: NavItem[]): any[] => items.map((item) => {
            const type = item.type || 'link';
            const obj: any = {};
            obj.type = type;
            if (item.navId) obj.id = item.navId;
            obj.title = item.title;
            if (type === 'link' || type === 'page') {
                obj.url = item.url || '';
                obj.target = item.target || '_self';
            }
            obj.visible = item.visible !== false;
            if (item.cssClass) obj.cssClass = item.cssClass;
            if (item.hideChildrenInParent) obj.hideChildrenInParent = true;
            if (item.matchThisURL) obj.matchThisURL = true;
            if (item.children?.length) obj.children = clean(item.children);
            return obj;
        });
        return clean(this.navItems);
    }

    private updatePreview(): void {
        if (this.jsonPreviewEl) {
            const schema = this.buildSchema();
            this.jsonPreviewEl.textContent = JSON.stringify(schema, null, 2);
        }
        const total = this.countAll(this.navItems);
        const countText = this.itemCountEl.querySelector('.item-count-text') as HTMLElement | null;
        const label = `${total} item${total !== 1 ? 's' : ''}`;
        if (countText) countText.textContent = label;
        else this.itemCountEl.textContent = label;
    }

    // ── Save / Copy ───────────────────────────────────────────────────
    private saveAndDownload(): void {
        this.syncFromDom();
        const schema = this.buildSchema();
        this.dispatchEvent(new CustomEvent('eum-nav-save', {
            bubbles: true, composed: true, detail: schema,
        }));

        const json = JSON.stringify(schema, null, 2);
        const blob = new Blob([json], { type: 'application/json' });
        const blobUrl = URL.createObjectURL(blob);
        const filename = 'navigation.json';
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
    }

    private copyJson(): void {
        const text = this.jsonPreviewEl?.textContent || '';
        const btn = this.shadow.getElementById('btn-copy')!;
        const restore = () => setTimeout(() => { btn.innerHTML = ICON.clipboard; }, 1800);
        const done = () => { btn.innerHTML = ICON.check; restore(); };

        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(done).catch(() => this.fallbackCopy(text, done));
        } else {
            this.fallbackCopy(text, done);
        }
    }

    private fallbackCopy(text: string, cb: () => void): void {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch { /* ignore */ }
        document.body.removeChild(ta);
        cb();
    }

    private fireChange(): void {
        this.setSaveStatus('modified');
        this.dispatchEvent(new CustomEvent('eum-nav-change', {
            bubbles: true, composed: true, detail: this.buildSchema(),
        }));
    }

    private setSaveStatus(state: 'saving' | 'saved' | 'modified' | 'failed' | 'hidden'): void {
        const el = this.shadow.getElementById('save-status');
        if (!el) return;
        el.classList.remove('text-bg-success', 'text-bg-warning', 'text-bg-danger', 'text-bg-secondary', 'd-inline-flex', 'align-items-center', 'gap-1');
        const setContent = (icon: string, label: string) => {
            el.innerHTML = `${icon}<span>${label}</span>`;
            el.classList.add('d-inline-flex', 'align-items-center', 'gap-1');
        };
        switch (state) {
            case 'saving':
                setContent(ICON.save, 'Saving…');
                el.classList.add('text-bg-secondary');
                el.hidden = false;
                break;
            case 'saved':
                setContent(ICON.check, 'Saved');
                el.classList.add('text-bg-success');
                el.hidden = false;
                break;
            case 'modified':
                setContent(ICON.asterisk, 'Modified');
                el.classList.add('text-bg-warning');
                el.hidden = false;
                break;
            case 'failed':
                setContent(ICON.exclamation, 'Save failed');
                el.classList.add('text-bg-danger');
                el.hidden = false;
                break;
            case 'hidden':
                el.hidden = true;
                break;
        }
    }

    // ── Import / Preview toggle ───────────────────────────────────────
    private async handleImportFile(input: HTMLInputElement): Promise<void> {
        const file = input.files?.[0];
        if (!file) return;
        try {
            const text = await file.text();
            const parsed = JSON.parse(text);
            if (!Array.isArray(parsed)) throw new Error('Root of imported JSON must be an array of nav items.');
            this.setSchema(parsed as NavSchema);
            this.fireChange();
        } catch (err) {
            console.error('Import failed:', err);
            this.toast.error('Could not import file: ' + ((err as Error)?.message || 'invalid JSON'), { title: 'Import failed' });
        } finally {
            input.value = '';
        }
    }

    private togglePreview(show: boolean): void {
        this.setSidebarVisible(show);
    }

    private toggleSidebar(): void {
        this.setSidebarVisible(!this.sidebarVisible);
    }

    private setSidebarVisible(show: boolean): void {
        const rightCol = this.shadow.getElementById('right-col') as HTMLElement | null;
        const leftCol = this.shadow.getElementById('left-col') as HTMLElement | null;
        const btn = this.shadow.getElementById('btn-toggle-sidebar') as HTMLButtonElement | null;
        if (!rightCol || !leftCol) return;
        this.sidebarVisible = show;
        rightCol.hidden = !show;
        leftCol.classList.toggle('col-lg-7', show);
        leftCol.classList.toggle('col-12', !show);
        if (btn) {
            btn.setAttribute('aria-pressed', show ? 'true' : 'false');
            btn.title = show ? 'Hide sidebar' : 'Show sidebar';
            btn.classList.toggle('btn-secondary', show);
            btn.classList.toggle('btn-light', !show);
        }
    }

    private setAdvancedMode(enabled: boolean): void {
        this.advancedMode = enabled;
        const sidebarEnabled = this.advancedMode || this.debugMode;
        const sidebarBtn = this.shadow.getElementById('btn-toggle-sidebar');
        sidebarBtn?.classList.toggle('d-none', !sidebarEnabled);
        this.setSidebarVisible(sidebarEnabled);
    }

    // ── Schemas panel (debug mode) ────────────────────────────────────
    private schemaSources: Record<'data' | 'template', { url: string; filename: string; text?: string }> = {
        data:     { url: '/schemas/nav-data.schema.json',     filename: 'nav-data.schema.json' },
        template: { url: '/schemas/nav-template.schema.json', filename: 'nav-template.schema.json' },
    };
    private activeSchemaTab: 'data' | 'template' = 'data';

    private initSchemasPanel(): void {
        const tabs = this.shadow.querySelectorAll<HTMLButtonElement>('#schema-tabs [data-schema-tab]');
        tabs.forEach(btn => btn.addEventListener('click', () => {
            const which = btn.dataset.schemaTab as 'data' | 'template';
            tabs.forEach(b => b.classList.toggle('active', b === btn));
            void this.showSchema(which);
        }));

        this.shadow.getElementById('btn-schema-copy')!.addEventListener('click', () => this.copySchema());
        this.shadow.getElementById('btn-schema-download')!.addEventListener('click', () => this.downloadSchema());

        void this.showSchema('data');
    }

    private async showSchema(which: 'data' | 'template'): Promise<void> {
        this.activeSchemaTab = which;
        const source = this.schemaSources[which];
        const preview = this.shadow.getElementById('schema-preview')!;
        const openLink = this.shadow.getElementById('btn-schema-open') as HTMLAnchorElement;
        const prompt = this.shadow.getElementById('schema-ai-prompt')!;

        openLink.href = source.url;

        if (!source.text) {
            preview.textContent = 'Loading…';
            try {
                const res = await fetch(source.url, { headers: { 'Accept': 'application/json' } });
                if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
                source.text = await res.text();
            } catch (err) {
                preview.textContent = `Failed to load ${source.url}: ${(err as Error).message}`;
                return;
            }
        }

        preview.textContent = source.text;
        prompt.textContent = this.buildAiPromptSnippet(which, source.url);
    }

    private buildAiPromptSnippet(which: 'data' | 'template', url: string): string {
        const absolute = new URL(url, window.location.origin).toString();
        const label = which === 'data' ? 'navigation data (NavItem tree)' : 'navigation rendering template';
        return [
            `You are producing ${label} for the EUM Portal.`,
            `Conform strictly to this JSON Schema: ${absolute}`,
            `Return JSON only — no prose, no code fences.`,
        ].join('\n');
    }

    private async copySchema(): Promise<void> {
        const source = this.schemaSources[this.activeSchemaTab];
        if (!source.text) await this.showSchema(this.activeSchemaTab);
        const text = source.text ?? '';
        const btn = this.shadow.getElementById('btn-schema-copy')!;
        const restore = () => setTimeout(() => { btn.innerHTML = ICON.clipboard; }, 1800);
        const done = () => { btn.innerHTML = ICON.check; restore(); };
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(done).catch(() => this.fallbackCopy(text, done));
        } else {
            this.fallbackCopy(text, done);
        }
    }

    private downloadSchema(): void {
        const source = this.schemaSources[this.activeSchemaTab];
        if (!source.text) return;
        const blob = new Blob([source.text], { type: 'application/schema+json' });
        const blobUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = source.filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
    }


    // ── Expand/Collapse all & Filter ──────────────────────────────────
    private setAllCollapsed(collapsed: boolean): void {
        this.syncFromDom();
        const walk = (items: NavItem[]) => {
            for (const it of items) {
                if (it.children?.length) {
                    it.collapsed = collapsed;
                    walk(it.children);
                }
            }
        };
        walk(this.navItems);
        this.renderTree();
    }

    private wireFilter(): void {
        const input = this.shadow.getElementById('nav-filter-input') as HTMLInputElement | null;
        const dropdown = this.shadow.getElementById('nav-filter-dropdown') as HTMLElement | null;
        const clearBtn = this.shadow.querySelector('.nav-filter-clear') as HTMLElement | null;
        if (!input || !dropdown || !clearBtn) return;

        const closeDropdown = () => { dropdown.hidden = true; this.filterActiveIdx = -1; };

        input.addEventListener('input', () => {
            clearBtn.hidden = !input.value.length;
            if (this.filterSearchTimer) clearTimeout(this.filterSearchTimer);
            this.filterSearchTimer = window.setTimeout(() => this.updateFilterResults(input.value), 120);
        });
        input.addEventListener('focus', () => {
            if (input.value.trim().length) this.updateFilterResults(input.value);
        });
        input.addEventListener('keydown', (e) => {
            const items = Array.from(dropdown.querySelectorAll('.list-group-item')) as HTMLElement[];
            if (e.key === 'Escape') { closeDropdown(); return; }
            if (!items.length || dropdown.hidden) return;
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
                e.preventDefault();
                this.filterActiveIdx += e.key === 'ArrowDown' ? 1 : -1;
                if (this.filterActiveIdx < 0) this.filterActiveIdx = items.length - 1;
                if (this.filterActiveIdx >= items.length) this.filterActiveIdx = 0;
                items.forEach((n, i) => n.classList.toggle('active', i === this.filterActiveIdx));
                items[this.filterActiveIdx].scrollIntoView({ block: 'nearest' });
            } else if (e.key === 'Enter') {
                e.preventDefault();
                const active = items[this.filterActiveIdx] || items[0];
                active?.click();
            }
        });
        clearBtn.addEventListener('click', () => {
            input.value = '';
            clearBtn.hidden = true;
            closeDropdown();
            if (this.filterId) { this.filterId = null; this.renderTree(); }
            input.focus();
        });
        this.shadow.addEventListener('mousedown', (e) => {
            const t = e.target as HTMLElement;
            if (!t.closest('.nav-filter-wrap')) closeDropdown();
        });
    }

    private updateFilterResults(text: string): void {
        const dropdown = this.shadow.getElementById('nav-filter-dropdown') as HTMLElement;
        const q = text.trim().toLowerCase();
        dropdown.innerHTML = '';
        this.filterActiveIdx = -1;
        if (!q) { dropdown.hidden = true; return; }

        this.syncFromDom();
        const matches: Array<{ item: NavItem; path: string }> = [];
        const walk = (items: NavItem[], trail: string[]) => {
            for (const it of items) {
                const nextTrail = [...trail, it.title || '(untitled)'];
                const hay = `${it.title || ''} ${it.url || ''} ${it.navId || ''}`.toLowerCase();
                if (hay.includes(q)) matches.push({ item: it, path: nextTrail.join(' › ') });
                if (it.children?.length) walk(it.children, nextTrail);
                if (matches.length >= 20) return;
            }
        };
        walk(this.navItems, []);

        if (!matches.length) {
            const empty = document.createElement('div');
            empty.className = 'list-group-item text-muted small';
            empty.textContent = 'No matching items';
            dropdown.appendChild(empty);
        } else {
            matches.forEach((m) => {
                const btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'list-group-item list-group-item-action';
                btn.innerHTML = `<div class="fw-semibold small">${this.escapeHTML(m.item.title || '(untitled)')}</div><div class="text-muted" style="font-size:.7rem;">${this.escapeHTML(m.path)}</div>`;
                btn.addEventListener('click', () => this.applyFilter(m.item.id, m.item.title || ''));
                dropdown.appendChild(btn);
            });
        }
        dropdown.hidden = false;
    }

    private applyFilter(id: string, label: string): void {
        this.syncFromDom();
        this.expandAncestorsOf(id);
        this.filterId = id;
        const input = this.shadow.getElementById('nav-filter-input') as HTMLInputElement;
        const dropdown = this.shadow.getElementById('nav-filter-dropdown') as HTMLElement;
        const clearBtn = this.shadow.querySelector('.nav-filter-clear') as HTMLElement;
        if (input) input.value = label;
        if (clearBtn) clearBtn.hidden = false;
        if (dropdown) dropdown.hidden = true;
        this.renderTree();
    }

    private expandAncestorsOf(id: string): void {
        const path: NavItem[] = [];
        const find = (items: NavItem[]): boolean => {
            for (const it of items) {
                if (it.id === id) return true;
                if (it.children?.length) {
                    path.push(it);
                    if (find(it.children)) return true;
                    path.pop();
                }
            }
            return false;
        };
        find(this.navItems);
        for (const ancestor of path) ancestor.collapsed = false;
    }

    // ── Utilities ─────────────────────────────────────────────────────
    private genId(): string { return `item_${this.nextId++}`; }
    // Strip quotes/angle-brackets/whitespace and keep only characters that are
    // valid in an HTML id (letters, digits, '-', '_', '.', ':').
    private sanitizeId(value: string | null | undefined): string {
        if (!value) return '';
        return value.replace(/[^A-Za-z0-9_\-.:]/g, '').slice(0, 128);
    }

    // Allow CSS class tokens (letters, digits, '-', '_') separated by spaces.
    // Strip quotes, angle brackets, and any other unsafe characters.
    private sanitizeCssClass(value: string | null | undefined): string {
        if (!value) return '';
        return value
            .replace(/[^A-Za-z0-9_\-\s]/g, '')
            .replace(/\s+/g, ' ')
            .trim()
            .slice(0, 256);
    }

    private isExternalUrl(url: string | null): boolean {
        if (!url || url === '#') return false;
        try {
            const parsed = new URL(url, window.location.href);
            return parsed.origin !== window.location.origin;
        } catch { return false; }
    }

    private findById(items: NavItem[], id: string): NavItem | null {
        for (const item of items) {
            if (item.id === id) return item;
            if (item.children?.length) {
                const found = this.findById(item.children, id);
                if (found) return found;
            }
        }
        return null;
    }

    private removeById(items: NavItem[], id: string): boolean {
        const idx = items.findIndex((i) => i.id === id);
        if (idx !== -1) { items.splice(idx, 1); return true; }
        for (const item of items) {
            if (item.children?.length && this.removeById(item.children, id)) return true;
        }
        return false;
    }

    private findParentContext(
        items: NavItem[], id: string, parentItem: NavItem | null = null
    ): { item: NavItem; parentItem: NavItem | null; siblings: NavItem[]; index: number } | null {
        for (let i = 0; i < items.length; i++) {
            if (items[i].id === id) return { item: items[i], parentItem, siblings: items, index: i };
            if (items[i].children?.length) {
                const found = this.findParentContext(items[i].children, id, items[i]);
                if (found) return found;
            }
        }
        return null;
    }

    private countAll(items: NavItem[]): number {
        return items.reduce((acc, it) => acc + 1 + this.countAll(it.children ?? []), 0);
    }
}

customElements.define('eum-navigation-builder', EumNavigationBuilder); 
